/**
 * @generated SignedSource<<230bc5a30863b9044e68876be01bd75a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCompanyLogo_company$data = {
  readonly logo: {
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly projectType: string | null | undefined;
  readonly " $fragmentType": "PaymentCompanyLogo_company";
};
export type PaymentCompanyLogo_company$key = {
  readonly " $data"?: PaymentCompanyLogo_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCompanyLogo_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCompanyLogo_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "logo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "fitIn",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": "url(fitIn:true)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "a8a0d7b6e93208c4daee226dae563e47";

export default node;
